export const STORED_VALUE_BASE_URL = '/stored-value';
